import React from "react";
import prosfiy_one from "assets/temp/porposify_slide_one.jpg";
import prosfiy_three from "assets/temp/porposify_slide_three.png";
import prosfiy_five from "assets/temp/Slide4.jpg";
import prosfiy_four from "assets/temp/porposify_slide_four.jpg";
import { ProposalTermsBlock } from "./ProposalTermsSection";

/** Original single-template layout (porposify slides + terms + footer). */
const LegacyProposalPreview = ({
  createdProposal,
  rowvalue,
  totalHour,
  selectedRange,
  wrapInRow = true,
}) => {
  const inner = (
    <>
      <img src={prosfiy_one} alt="" />

      <ProposalTermsBlock
        createdProposal={createdProposal}
        rowvalue={rowvalue}
        totalHour={totalHour}
        selectedRange={selectedRange}
      />
      <img src={prosfiy_three} alt="" />
      <img src={prosfiy_five} alt="" />
      <img style={{ marginTop: "20px" }} src={prosfiy_four} alt="" />
    </>
  );
  if (!wrapInRow) return inner;
  return <div className="row border-left g-0">{inner}</div>;
};

export default LegacyProposalPreview;
